import React from 'react';
import {BANNER_TYPE} from "constants/commons";
import CustomBanner from "../carousel";
import ViewAllTitle from "components/ViewAllTitle";

const BrandWeek = ({mobile}) => {
  return (
    <div className={`${mobile ? "mt-4" : "mt-2"} w-full text-rand-100`}>
      {mobile && <ViewAllTitle title="Nepali brands" mobile={mobile}/>}
      <CustomBanner bannerType={BANNER_TYPE.brand_week} mobile={mobile} showDotIndicator={true} showArrowButton={true}/>
    </div>

  );
};

export default React.memo(BrandWeek);